import { Fragment, useEffect, useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TimeCountDown from "../../components/countdown";
import Bg2 from '../../images/shapes/shape_bg_ico_countdown.svg';
import Bg from '../../images/shapes/shape_net_ico_hero_section_bg.svg';
import SaleModal from "../../components/SaleModal";
import BeforeAfterSaleModal from "../../components/BeforeAfterSaleModal";
// import axios from "axios";

const PreSalePage = () => {
    const [showSaleModal, setShowSaleModal] = useState(false);
    const [saleTitle, setSaleTitle] = useState('Sale Starts Soon');
    const [saleIsLive, setSaleIsLive] = useState(false);
    const [percentage, setPercentage] = useState(0);
    const [xrpRaised, setXrpRaised] = useState(0);

    const fetchBalance = async () => {
        // const response = await axios.get('https://server.nimanode.com/api/balance');
        // const totalRaised = parseFloat(JSON.parse(response.data.balance));
        // const totalRaised = 0;
        //   setXrpRaised(totalRaised);
          setXrpRaised(0);
    
        // const percentage = parseFloat(((totalRaised / 50000) * 100).toFixed(2));
        const percentage = 0;
        setPercentage(percentage);
    
      }
    
      useEffect(() => {
        fetchBalance();
      }, [])

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                    <main className="page_content">
                        <section className="ico_hero_section section_decoration text-center" style={{ backgroundImage: `url(${Bg})` }}>
                            <div className="container presale-container">
                                <div data-aos="fade-up" data-aos-duration="900" data-aos-delay="200">
                                    <div className="ico_countdown_progress_box">
                                        <div className="ico_heading_block text-center mb-10">
                                            <h1 className="highlight_title mb-0">
                                            Nimanode presale details
                                            </h1>
                                            <p>Secure your $NMA to Build and Deploy AI Agents that work for you.</p>
                                            <p style={{ fontWeight: 'bold' }}>LISTING ON XRP DEX @ 25% HIGHER</p>
                                            <ul className='unordered_list justify-content-between' style={{ fontWeight: 'bold' }}>
                                                <li>Ticker - NMA</li>
                                                <li>Access type - Public</li>
                                            </ul>
                                            {/* <h3>Nimanode Presale Details</h3> */}
                                            <ul className='unordered_list justify-content-between' style={{ fontWeight: 'bold' }}>
                                                <li>Presale Allocation - 90,000,000</li>
                                                <li>Sale Price - 1 XRP = 450 $NMA</li>
                                            </ul>
                                            <ul className='unordered_list justify-content-between' style={{ fontWeight: 'bold' }}>
                                                <li>Minimum buy - 200XRP</li>
                                                <li>Maximum buy - 20,000XRP</li>
                                            </ul>
                                            <ul className='unordered_list justify-content-center' style={{ fontWeight: 'bold' }}>
                                                <li>Token distribution - Immediately Presale Ends</li>
                                            </ul>
                                        </div>
                                        <div className='countdownbg' style={{ backgroundImage: `url(${Bg2})` }}>
                                            <TimeCountDown targetDate="2025-05-22T15:00:00Z" endDate="2025-07-01T15:00:00Z" setSaleTitle={setSaleTitle} setSaleIsLive={setSaleIsLive} />
                                        </div>
                                        <div className="ico_progress">
                                            <div className="progress">
                                                <div className="progress-bar" role="progressbar" aria-valuenow={percentage} aria-valuemin="0" aria-valuemax="100" style={{ width: `${percentage}%` }}></div>
                                            </div>
                                            <ul className="progress_range_step unordered_list justify-content-end" style={{ fontWeight: 'bold' }}>
                                                <li>Soft Cap</li>
                                                {/* <li>Hard Cap</li> */}
                                            </ul>
                                            <ul className="progress_value unordered_list justify-content-between" style={{ fontWeight: 'bold', marginBottom: '50px'}}>
                                                <li>Total Raised: { xrpRaised.toLocaleString() } XRP</li>
                                                <li>
                                                    <button onClick={() => setShowSaleModal(prev => !prev)} className="ico_btn_outline">Buy $NMA</button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                <Footer />
                { showSaleModal ? (saleIsLive ? <SaleModal setShowSaleModal={setShowSaleModal} /> : <BeforeAfterSaleModal setShowSaleModal={setShowSaleModal} title={saleTitle} />) : '' }
                {/* { showSaleModal ? (saleIsLive ? <SaleModal setShowSaleModal={setShowSaleModal} /> : <SaleModal setShowSaleModal={setShowSaleModal} />) : '' } */}
            </div>
        </Fragment>
    )
}

export default PreSalePage;